interface Number {
    /**
     * On fixe les décimales à 2 et on sépare les numéro par groupes de 3.
     */
    priceFormat(): string
}

Number.prototype.priceFormat = function(): string {
    return parseFloat(this.toFixed(2)).toLocaleString()
}
